import { useTradingStatus } from '../hooks/useTradingStatus';

interface TradingModeBadgeProps {
  className?: string;
  showCaption?: boolean;
}

export default function TradingModeBadge({
  className = '',
  showCaption = false,
}: TradingModeBadgeProps) {
  const status = useTradingStatus();
  const mode = status?.trading_mode ?? 'paper';
  const liveEnabled = mode === 'live' && status?.live_trading_enabled;
  const locked = !liveEnabled;
  const guardLabel = liveEnabled ? '실전 주문 허용' : mode === 'live' ? '실전 주문 잠김' : '주문 잠김';

  return (
    <div className={`trading-mode-badge ${className} ${mode}${locked ? ' locked' : ''}`}>
      {showCaption && <span className="mode-label">주문 상태</span>}
      <span className="status-dot"></span>
      <strong>{guardLabel}</strong>
    </div>
  );
}
